<template>
  <px-show-large-text :large-text="value" :truncate-value="120"/>
</template>

<script>
import UserTipoNotificacao from '@/enums/user-tipo-notificacao';
import CompradorTipoNotificacao from '@/enums/comprador-tipo-notificacao';

export default {
  props: {
    tipoNotificacao: {
      type: String,
      required: true,
    },
    isNotificacaoComprador: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
      tipoNotificacaoEnum: this.isNotificacaoComprador
        ? CompradorTipoNotificacao : UserTipoNotificacao,
    };
  },
  created() {
    if (!this.tipoNotificacao) {
      return;
    }
    this.value = this.tipoNotificacaoEnum.keys[this.tipoNotificacao].description;
  },
};
</script>
